import React, {
    FC
  } from 'react';
import { Checkbox } from '@blueprintjs/core';
import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';

const CheckBoxCellRenderer: FC<ICellRendererParams> = (props) => {
const { value, node, colDef } = props;
const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (colDef && colDef.field) {
        node.setDataValue(colDef?.field, event.target.checked);
    }
};
return <Checkbox checked={value} onChange={handleChange} />;
};
export default CheckBoxCellRenderer;
